import { Seo } from '../components/Seo';
import { Reveal } from '../components/Reveal';
import { CtaBand } from '../components/CtaBand';
import { BRAND } from '../lib/brand';
import { INSTAGRAM_TAROMANCE_URL } from '../lib/externalLinks';

const PROGRAMS = [
  {
    title: '타로 베이직 클래스',
    description: '메이저 아르카나 22장을 5회에 걸쳐 배우는 입문 과정. 카드 상징부터 실전 리딩의 기초까지 다룹니다.',
    meta: '소수 정원 · 5회 과정'
  },
  {
    title: '원데이 클래스',
    description: '모임과 단체를 위한 하루짜리 타로 체험 클래스. 리더십, 커뮤니케이션 등 주제형 구성도 가능합니다.',
    meta: '모임 · 기업 출강 가능'
  },
  {
    title: '타로 콘텐츠 컨설팅',
    description: '타로 서적 출판, 타로카드 제작, 펀딩 프로젝트 운영 경험을 바탕으로 타로 기반 콘텐츠 기획을 돕습니다.',
    meta: '프로젝트 단위 협의'
  }
];

export function EducationConsultingPage() {
  return (
    <div className="tm-page">
      <Seo
        title="클래스 & 컨설팅 | 타로맨스"
        description="타로 기초 클래스, 모임·기업 출강, 타로 콘텐츠 제작 컨설팅. 타로맨스의 교육 프로그램을 소개합니다."
      />

      <section className="tm-page-hero">
        <div className="tm-container">
          <Reveal>
            <p className="tm-eyebrow">Class & Consulting</p>
            <h1 className="tm-display">
              바 너머의 타로,
              <br />
              <em>배움과 프로젝트</em>
            </h1>
            <p className="tm-lede">
              타로맨스는 매장 밖에서도 타로를 만듭니다. 타로 서적 출판, 타로카드 제작, 펀딩 프로젝트,
              앱 개발까지 — 그 경험을 클래스와 컨설팅으로 나눕니다.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="tm-section">
        <div className="tm-container">
          <div className="tm-content-grid">
            {PROGRAMS.map((program, index) => (
              <Reveal key={program.title} className="tm-content-card" delay={index * 80}>
                <span className="tm-tag">{program.meta}</span>
                <h3 className="tm-h3">{program.title}</h3>
                <p className="tm-body-text">{program.description}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="tm-section tm-section--line tm-section--deep">
        <div className="tm-container">
          <div className="tm-split">
            <Reveal>
              <p className="tm-eyebrow">Inquiry</p>
              <h2 className="tm-h2">강의·컨설팅 문의</h2>
              <p className="tm-lede">
                일정과 구성은 목적에 맞춰 조율합니다. 이메일 또는 인스타그램 DM으로 문의해 주세요.
              </p>
            </Reveal>
            <Reveal delay={100}>
              <div className="tm-contact-grid">
                <a className="tm-contact-item" href={`mailto:${BRAND.email}`}>
                  <h3>Email</h3>
                  <strong>{BRAND.email}</strong>
                  <span>클래스 일정 · 출강 · 컨설팅 제안</span>
                </a>
                <a className="tm-contact-item" href={INSTAGRAM_TAROMANCE_URL} target="_blank" rel="noreferrer">
                  <h3>Instagram DM</h3>
                  <strong>@taromance</strong>
                  <span>간단한 문의는 DM이 가장 빠릅니다</span>
                </a>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CtaBand title="타로를 배우고 싶다면, 함께 만들고 싶다면." secondaryLabel="타로 상담 안내" secondaryTo="/tarot-consultation" />
    </div>
  );
}
